import { useCallback } from "react";
import { UserCardData } from "@/components";

export const useCardLock = (userData: any) => {
  const isCardLocked = useCallback(
    (card: UserCardData) => {
      if (!userData?.uid) return false;

      const isOwnCard = userData.uid === card.uid;

      const viewerHasPlan = !!userData?.planInfo?.active;
      const targetHasPlan = !!card?.planInfo?.active;

      return !isOwnCard && !viewerHasPlan && targetHasPlan;
    },
    [userData],
  );

  return { isCardLocked };
};
